import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "RequestSentModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "RequestSentModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content border-0 bg-transparent position-relative" }
const _hoisted_4 = { class: "modal-body bg-white rounded-3 p-4 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bolder mb-5" }, "Your booking has been sent to the venue.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold" }, "Download the app to keep track and discover new features for your dine in experience.", -1)
const _hoisted_9 = { class: "mt-5" }
const _hoisted_10 = {
  key: 0,
  class: "list-inline"
}
const _hoisted_11 = { class: "list-inline-item mb-2" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/apple-store-gray.png",
  height: "45"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "list-inline-item" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/google-play-gray.png",
  height: "45"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            class: "fa-2x btn btn-primary btn-circle text-white b-modal-close",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectToPage()))
          }, _hoisted_6),
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_ctx.social_links)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createElementVNode("a", {
                      href: _ctx.social_links.ios_link,
                      target: "_blank"
                    }, _hoisted_14, 8, _hoisted_12)
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _createElementVNode("a", {
                      href: _ctx.social_links.android_link,
                      target: "_blank"
                    }, _hoisted_18, 8, _hoisted_16)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}